import React, { useCallback, useEffect, useState } from "react";
import { api, euro, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { TopupRequestDialog } from "@/components/TopupRequestDialog";

export const LowPlafondPanel = ({ onSent = () => {} }) => {
  const [data, setData] = useState(null);
  const [threshold, setThreshold] = useState("");
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    try { const { data: d } = await api.get("/admin/low-plafond"); setData(d); setThreshold(String(d.threshold)); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Elenco non disponibile"); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const save = async () => {
    setBusy(true);
    try { const { data: d } = await api.put("/admin/low-plafond/settings", { threshold: Number(threshold) }); setData(d); toast.success("Soglia salvata"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Salvataggio non riuscito"); }
    finally { setBusy(false); }
  };
  const sent = () => { load(); onSent(); };
  return (
    <Card className="p-5 space-y-4" data-testid="low-plafond-panel">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-head text-lg font-semibold flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-amber-500" /> Dealer con Plafond servizi basso</h2>
          <p className="text-xs text-muted-foreground mt-1">Ogni mattina ricevi un avviso. Per ognuno ti proponiamo l'importo dell'ultima ricarica pagata. Le richieste senza pagamento ricevono un sollecito automatico dopo 3 giorni.</p>
        </div>
        <div className="flex items-end gap-2">
          <label className="text-sm">Soglia (€)<Input type="number" min="0" step="1" className="mt-1 w-28" value={threshold} onChange={(e) => setThreshold(e.target.value)} data-testid="low-plafond-threshold" /></label>
          <Button next size="sm" variant="outline" disabled={busy || threshold === ""} onClick={save} data-testid="low-plafond-save">Salva</Button>
        </div>
      </div>
      {data && data.items.length === 0 && <p className="text-sm text-muted-foreground" data-testid="low-plafond-empty">Nessun dealer sotto {euro(data.threshold)}.</p>}
      <div className="divide-y divide-border">
        {data?.items.map((d) => (
          <div key={d.id} className="flex flex-wrap items-center justify-between gap-3 py-3" data-testid={`low-plafond-row-${d.id}`}>
            <div className="min-w-0">
              <p className="font-medium truncate">{d.name}{d.is_master && <Badge variant="outline" className="ml-2 text-[10px]">Master</Badge>}</p>
              <p className="text-xs text-muted-foreground">Plafond attuale <span className="text-destructive font-semibold" data-testid={`low-plafond-balance-${d.id}`}>{euro(d.balance)}</span> · proposta {euro(d.suggested)}</p>
            </div>
            {d.request_open ? <Badge variant="secondary" data-testid={`low-plafond-open-${d.id}`}>Richiesta già inviata</Badge>
              : <TopupRequestDialog dealer={d} initialAmount={d.suggested} label={`Proponi ricarica ${euro(d.suggested)}`} onSent={sent} testId={`low-plafond-request-${d.id}`} />}
          </div>
        ))}
      </div>
    </Card>
  );
};
